export { default as useAnalyticsTags } from './useAnalyticsTags';
